import { createContext, type ReactNode, useContext } from 'react';
import { useQuyDoiDonViTinhChiTietExport } from './hooks';

interface QuyDoiDonViTinhChiTietContextValue {
  exportToExcel: () => Promise<void>;
  canExport: boolean;
  isExporting: boolean;
}

const QuyDoiDonViTinhChiTietContext = createContext<QuyDoiDonViTinhChiTietContextValue | null>(null);

export const useQuyDoiDonViTinhChiTietContext = () => {
  const context = useContext(QuyDoiDonViTinhChiTietContext);
  if (!context) {
    throw new Error('useQuyDoiDonViTinhChiTietContext must be used within QuyDoiDonViTinhChiTietProvider');
  }
  return context;
};

export const QuyDoiDonViTinhChiTietProvider = ({ children }: { children: ReactNode }) => {
  const { exportToExcel, canExport, isExporting } = useQuyDoiDonViTinhChiTietExport();

  return (
    <QuyDoiDonViTinhChiTietContext.Provider
      value={{
        exportToExcel,
        canExport,
        isExporting
      }}
    >
      {children}
    </QuyDoiDonViTinhChiTietContext.Provider>
  );
};
